export const GlobalSourceIds = {
    IndoorStandSymbols: 'IndoorStandSymbols',
    IndoorStandWalls_Inner: 'IndoorStandWalls_Inner',
    IndoorStandWalls_Outer: 'IndoorStandWalls_Outer',
    Labels: 'Labels'
};

export const GlobalLayerIds = {
    IndoorStandSymbols: GlobalSourceIds.IndoorStandSymbols + '|symbol',
    IndoorStandCircles: GlobalSourceIds.IndoorStandSymbols + '|circle',
    IndoorStandWalls_Inner: GlobalSourceIds.IndoorStandWalls_Inner + '|wall',
    IndoorStandWalls_Outer: GlobalSourceIds.IndoorStandWalls_Outer + '|wall',
    Labels: GlobalSourceIds.Labels + '|symbol'
};

export const CLICKABLE_LAYER_IDS = [
    GlobalLayerIds.IndoorStandSymbols,
    GlobalLayerIds.IndoorStandCircles,
    GlobalLayerIds.IndoorStandWalls_Inner,
    GlobalLayerIds.IndoorStandWalls_Outer,
    GlobalLayerIds.Labels
];
